export const success = 'Password successfully copied to clipboard'